import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const generatePlan = createAsyncThunk(
  "plan/generatePlan",
  async (data) => {

    const res = await fetch(
      "https://api.washim.org/api/plan",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      }
    );

    return res.json();
  }
);

const planSlice = createSlice({

  name: "plan",

  initialState: {
    plan: "",
    loading: false
  },

  reducers: {},

  extraReducers: (builder) => {

    builder.addCase(generatePlan.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(generatePlan.fulfilled, (state, action) => {
      state.plan = action.payload.plan;
      state.loading = false;
    });

  }

});

export default planSlice.reducer;